//natives
import React, { Component, createRef } from 'react';
import moment from 'moment';
import Cookies from 'universal-cookie';
import dateFormat from 'dateformat';
import formatCurrencytoBr from 'format-currency-to-br';
import TagManager from 'react-gtm-module';

//util
import Alerta from '../../snackbars/.mixins';

//childrens
import PedidosLista from '../childrens/PedidosLista/.mixins/PedidosLista';
import {
    CustomSortAgendados,
    CustomSortPendentes
} from '../childrens/customSort/.mixins';
import {ColTodosPedidos} from '../childrens/columns/.mixins';
import { AuthContext } from '../../../../contexts/AuthContext';

//constrollers
import Pedidos_controller from '../../../../controllers/pedido';
import Pessoas_controller from '../../../../controllers/pessoa';
import Config from '../../../../controllers/config';
import Log from '../../../../controllers/log';

export default class Pedidos extends Component {
    static contextType = AuthContext;

    constructor(props) {
        super(props);

        this.child = createRef();
        this.inputRef = createRef();
        this.permissions = {};

        this.state = {
            itens: [],
            itensTable: [],
            title: props.route.title,
            columns: ColTodosPedidos(this),
            isLoading: true,
            isError: false,
            error: null,
            fontSize: '8pt',
            nameCSV: props.route.title,
            filters: {
                datas: false,
                flagsPag: false,
                adminFilter: false,
            },
            fornecedor: 0,
            customSort: null,
            onCellClick: (colData, cellMeta) => {
                this.handlerOnClick(colData, cellMeta, this);
            }
        }
        
        //binds
        this.setState = this.setState.bind(this);
        this.cancelarPedido = this.cancelarPedido.bind(this);
        this.loadData = this.loadData.bind(this);
        
    }

    UNSAFE_componentWillMount() {
        this.permissions = this.context.user.permissions;

        this.setState({
            filters: {
                ...this.state.filters,
                adminFilter: !!this.permissions["filtro-fornecedor"],
            }
        });
        
        this.loadData(null);
    }

    componentDidMount() {
        if (this.props.route.link === 'pendentes') {
            this.setState({
                customSort: CustomSortPendentes
            });
        } else {
            this.setState({
                customSort: CustomSortAgendados
            });
        }

        // TagManager.dataLayer({
        //     dataLayer: {
        //       event: 'event',
        //       eventCategory: 'tokstok:fornecedores:consulta-pedidos',
        //       eventAction: 'componentDidMount',
        //       eventLabel: `renderiza-componente-${this.state.title}`,
        //     }
        // });

        //auditoria
        const cookies = new Cookies();
        const token = cookies.get('User-Token');
        Log.info(token,"Efetuado carregamento da tela Consulta Pedidos "+this.props.route.title+"!");
    }

    UNSAFE_componentWillReceiveProps() {
        this.setState({
            title: this.props.route.title,
        });
        this.loadData(null);
    }

    splitDateString(dateString) {
        return dateString ? dateString.split(' ')[0] : ''
    }

    async loadData(filters) {
        const cookies = new Cookies();
        const token = cookies.get('User-Token');

        if(!this.state.filters.adminFilter){
            // Dados id pessoa
            try {
                const o_pessoa = await Pessoas_controller.getByToken(token);
                let j_pessoa = JSON.parse(o_pessoa.body);
                if (o_pessoa.res.statusCode === 200) {
                    this.setState({ fornecedor: j_pessoa.itens.codigo });

                    //auditoria
                    let str = `Efetuada requisição para retorno de dados de pessoa! 
                    Response:( Method: ${o_pessoa.res.request.method}
                    , StatusCode: ${o_pessoa.res.statusCode}
                    , Body: (limited 100chars)${o_pessoa.body.substr(0, 100)} )`;
                    Log.info(token, str);
                } else {
                    throw new Error("Ocorreu um problema ao carregar as informações do usuário. Por favor, tente novamente.");
                }
            } catch (error) {
                let errorString = "Erro ao carregar dados!";
                if (Config.DEBUG === "TRUE")
                    errorString = error.message;
                this.setState({
                    isError: true,
                    isLoading: false,
                    error: errorString
                });
                this.childAlerta.current.retorno(error.message, 'error');
            }
        }

        // Dados dos pedidos
        try {
            
            let r_pedidos = null;
            let j_r_pedidos = null;
            this.setState({isLoading:true});

            // define filtros
            const filters = {
                personId: this.state.fornecedor
            };
            
            if (this.props.route.link === 'pendentes') {
                filters.scheduleIs = "N";
                r_pedidos = await Pedidos_controller.getAgendados(token,filters);
            } else {
                filters.scheduleIs = "A";
                r_pedidos = await Pedidos_controller.getAgendados(token,filters);
            }

            j_r_pedidos = JSON.parse(r_pedidos.body);

            if (r_pedidos.res.statusCode === 200) {
                let arrayItens = [];
                if (j_r_pedidos.length > 0) {
                    arrayItens = j_r_pedidos.map(e => {
                        return {
                            NR_PC: e.purchaseOrderId,
                            ID_PROD: e.productId,
                            CD_NUM: e.numericCode,
                            NM_PROD: e.productName,
                            AB_COR1: e.colorAbbreviation,
                            ROTACAO: e.rotation,
                            DT_EMIS: this.splitDateString(e.issueDate),
                            DT_ENTR: this.splitDateString(e.deliveryDateOrigin),
                            DT_PREV_ENTRG: this.splitDateString(e.expectedDeliveryDate),
                            DT_AGENDADA: this.splitDateString(e.scheduleDate),
                            DS_RUPTURA: e.breakageDescription,
                            QT_ITEM: e.itemQuantity,
                            ID_PESSOA: e.personId,
                            NM_PESSOA: e.personName,
                            VM_UNIT: formatCurrencytoBr(e.unitaryValue),
                            VP_IPI: `${e.percentValueIPI}%`,
                            QT_PREV: e.forecastQuantity,
                            VL_TOT: formatCurrencytoBr(e.amount),
                            QT_ENTRG: e.quantityDelivery,
                            QT_PEND: e.quantityOutstanding,
                            VL_PEND: formatCurrencytoBr(e.outstandingAmount),
                            QD_VOL_PEND: e.amountOutstandingVolume,
                            DS_GEP: e.GEPDescription,
                            CD_FAM: e.familyId,
                            DS_TIPO_PEDIDO: e.orderTypeDescription,
                            CD_PAGTO: e.paymentId,
                            CD_FIL_ENTRG: e.branchDeliveryId,
                            CD_ALFA: e.alphaId,
                            NCM: e.mercosurCommonName,
                            IN_TIPO_PED: e.orderType,
                            ID_PERMITE_CANCEL: e.allowCancelIs,
                            QT_AGENDA: e.scheduleQuantity,
                            QT_VOL_AGENDA: e.quantityVolumeSchedule,
                            IQ1: e.qualityIndex1,
                            NM_FIL: e.branchName,
                            DT_ENTRG: this.splitDateString(e.deliveryDate),
                            VM_PENALZ_AGENDA: e.monetaryPenaltySchedule,
                            VP_DESC: `${e.percentDiscont}%`,
                            VM_DESC: formatCurrencytoBr(e.monetaryDiscont),
                            VL_LIQ_COM_DESC: formatCurrencytoBr(e.netDiscount),
                            SOLIC_ANTEC: e.advanceRequest,
                            DS_STATUS_SCIA: e.sciaStatusDescription,
                            CD_PAGTO_IPC: e.IPCpayment,
                            CD_PAGTO_FORNEC: e.supplierPayment,
                            DS_MOTIVO_RECUSA: e.rejectionReasonDescription,
                            DT_AGE_SUG_FORNEC: this.splitDateString(e.suggestedScheduleDate),
                            QT_TOTAL_REGS: e.totalRows,
                            PDF: {
                                CD_FIL: e.branchId, 
                                NR_PC: e.purchaseOrderId,
                                LANGUAGE: 'PT-BR'
                            },
                            PDF_INGLES: {
                              CD_FIL: e.branchId, 
                              NR_PC: e.purchaseOrderId,
                              LANGUAGE: 'EN'
                            },
                            ACOES: {
                                CD_FIL: e.branchId, 
                                DT_ENTRG: this.splitDateString(e.deliveryDate),
                                ID_PROD: e.productId,
                                NR_PC: e.purchaseOrderId,
                                ID_PERMITE_CANCEL: e.allowCancelIs
                            }
                        };
                    });
                }
                this.setState({
                    itensTable: arrayItens,
                    isLoading: false,
                });

                // TagManager.dataLayer({
                //     dataLayer: {
                //       event: 'event',
                //       eventCategory: 'tokstok:fornecedores:consulta-pedidos',
                //       eventAction: 'callback',
                //       eventLabel: 'sucesso',
                //     }
                // });
            } else {
                if (
                    j_r_pedidos.status == false && 
                    j_r_pedidos.message && 
                    j_r_pedidos.message.includes("Token inválido!")
                ) {
                    this.child.current.retorno('Autentificação inválida!','error');
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                } else if (
                    j_r_pedidos.status == false && 
                    j_r_pedidos.message && 
                    (
                        j_r_pedidos.message.includes("Campos necessários") ||
                        j_r_pedidos.message.includes("Permissão")
                    )
                ) {
                    throw new Error(j_r_pedidos.message);
                } else {
                    throw new Error("O ocorreu um erro no sistema!");
                }
            }

            //auditoria
            let str = "Efetuada requisição para recuperação de dados de pedidos! "
            +"Response:( Method: "+r_pedidos.res.request.method
            +", StatusCode: "+r_pedidos.res.statusCode
            +", Body: (limited 100chars)"+r_pedidos.body.substr(0,100)
            +" )";
            Log.info(token,str);
        } catch (error) {
            this.child.current.retorno('Erro ao carregar dados!','error');
            let errorString = "Erro ao carregar dados!";
            if (Config.DEBUG === "TRUE")
                errorString = error.message;
            this.setState({
                isError: true,
                isLoading: false,
                error: errorString
            });

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:consulta-pedidos',
            //       eventAction: 'callback',
            //       eventLabel: `erro:lista-${this.state.title}`,
            //     }
            // });

            //auditoria
            let str = "Erro na recuperação de dados de pedidos! "
            +"Error:( Message: "+error.message+", Stack: "+error.stack+" )";
            Log.error(token,str);
        }

    }

    convStringDate(dateString) {
        let dateParts = dateString.split("/");
        return new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
    }

    async loadDataAgendamentos(props) {
        const cookies = new Cookies();
        const token = cookies.get('User-Token');

        try {
            let r_datas = await Pedidos_controller.getDataAgendamentos(token);
            let j_r_datas = JSON.parse(r_datas.body);

            if (r_datas.res.statusCode === 200) {
                let array = [];
                j_r_datas.itens.forEach(element => {
                    array.push(new Date(dateFormat(new Date(element),'yyyy-mm-dd')+' 00:00:00'));
                });
                props.setState({
                    dataAgendamentos: array,
                    isLoading: false
                });
            } else {
                if (
                    j_r_datas.status == false && 
                    j_r_datas.message && 
                    j_r_datas.message.includes("Token inválido!")
                ) {
                    props.child.current.retorno('Autentificação inválida!','error');
                    setTimeout(function() {
                        window.location.reload();
                    }, 1000);
                } else {
                    throw new Error("Campos necessários, não foram retornados pelo servidor!");
                }
            }

            //auditoria
            let str = "Efetuada requisição para recuperação de Datas para agendamento! "
            +"Response:( Method: "+r_datas.res.request.method
            +", StatusCode: "+r_datas.res.statusCode
            +", Body: (limited 100chars)"+r_datas.body.substr(0,100)
            +" )";
            Log.info(token,str);
        } catch (error) {
            props.child.current.retorno('Erro ao carregar dados!','error');
            let errorString = "Erro ao carregar dados!";
            if (Config.DEBUG === "TRUE")
                errorString = error.message;
            props.setState({
                isError: true,
                isLoading: false,
                error: errorString
            });

            //auditoria
            let str = "Erro na recuperação de Datas para agendamento! "
            +"Error:( Message: "+error.message+", Stack: "+error.stack+" )";
            Log.error(token,str);
        }

    }

    async cancelarPedido(body) {
        const cookies = new Cookies();
        const token = cookies.get('User-Token');
        
        try {
            const r_pedido = await Pedidos_controller.updatePedidos(token,body);
            const j_r_pedido = JSON.parse(r_pedido.body);
            
            if (r_pedido.res.statusCode === 200) {
                this.child.current.retorno(j_r_pedido.message,'success');
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            } else {
                if (
                    j_r_pedido.status == false && 
                    j_r_pedido.message && 
                    j_r_pedido.message.includes("Token inválido!")
                ) {
                    this.child.current.retorno('Autentificação inválida!','error');
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                } else {
                    throw new Error("Campos necessários, não foram retornados pelo servidor!");
                }
            }

            //auditoria
            let str = "Efetuada requisição para cancelamento de pedido! "
            +"Response:( Method: "+r_pedido.res.request.method
            +", StatusCode: "+r_pedido.res.statusCode
            +", Body: (limited 100chars)"+r_pedido.body.substr(0,100)
            +" )";
            Log.info(token,str);
        } catch (error) {
            this.child.current.retorno('Não foi possivel enviar pedido!','error');
            let errorString = "Não foi possivel enviar pedido!";
            if (Config.DEBUG === "TRUE")
                errorString = error.message;
            this.child.current.retorno(errorString,'error');

            //auditoria
            let str = "Erro na requisição para cancelamento de pedido! "
            +"Error:( Message: "+error.message+", Stack: "+error.stack+" )";
            Log.error(token,str);
        }

    }

    handlerOnClick(colData, cellMeta, props) {
        const i = cellMeta.dataIndex;
        const register = props.state.itensTable[i];

        TagManager.dataLayer({
            dataLayer: {
              event: 'event',
              eventCategory: 'tokstok:fornecedores:pendentes',
              eventAction: 'clique:pedido',
              eventLabel: register.NR_PC,
            }
        });
    }

    render() {
        return(
            <div>
                <PedidosLista {...this}/>
                <br/>
                <Alerta ref={this.child}/>
            </div>
        );
    }

}